module.exports = new __parcel__URL__("monsterMaker.374355b0.jpg").toString();